<!--
  @author:sunluhua
  @time:2020/9/14
  @disc:销售计划导出3
 -->
<template>
  <div class="sale-query">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="96px">
      <!-- <el-form-item label="组织编码" prop="deptName">
        <el-input v-model="form.orgCode" placeholder="请输入对账单号"></el-input>
      </el-form-item>
      <el-form-item label="经营组织" prop="ces4">
        <ajax-select
          v-model="form.organization"
          type="org"></ajax-select>
      </el-form-item>
      <el-form-item label="客户名称" prop="ces5">
        <search-select
          v-model="form.custom"
          type="customer"
          valueField="id"
          clearable
          placeholder="请输入客户名称"></search-select>
      </el-form-item>
      <el-form-item label="币种" prop="ces3">
        <el-select v-model="form.ces3" placeholder="请选择">
          <el-option
            v-for="item in moneyType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="对账单号" prop="deptName">
        <el-input v-model="form.verifyNo" placeholder="请输入对账单号"></el-input>
      </el-form-item>
      <el-form-item label="是否有差异" prop="orderType">
        <el-select v-model="form.isDifferent" placeholder="请选择">
          <el-option
            v-for="item in typeArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对账日期" prop="tareWeightTime">
        <el-date-picker
          v-model="form.tareWeightTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
        <el-button type="primary" v-permission="'0210501'" @click="add">新增</el-button>
        <el-button type="primary" v-permission="'0210502'" @click="automatic" >自动对账设置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      tooltip-effect="light"
      ref="multipleTable">
      <!-- <el-table-column
        prop="orgCode"
        label="组织编码"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="customerCode"
        label="客户名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="gjahr"
        label="会计年度"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="金额"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="currencyType"
        label="币种"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-show="scope.row.currencyType == '1'">CNY</span>
          <span v-show="scope.row.currencyType == '2'">USD</span>
          <span v-show="scope.row.currencyType == '3'">EUR</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="racct"
        label="科目号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="bldat"
        label="交易日期"
        show-overflow-tooltip>
      </el-table-column> -->
      <!-- <el-table-column
        prop="customerCode"
        label="客户名称"
        show-overflow-tooltip>
      </el-table-column>                         -->
      <el-table-column
        prop="verifyNo"
        label="对账单号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="verifyDateStart"
        label="对账日期"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="isDifferent"
        label="是否有差异"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-show="scope.row.isDifferent == '0'">否</span>
          <span v-show="scope.row.isDifferent == '1'">是</span>
        </template>
      </el-table-column>
       <el-table-column
        prop="createTime"
        label="创建时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="createPerson"
        label="创建人"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="logisticsMode"
        label="操作"
        :formatter="logisticsModeFormat"
        show-overflow-tooltip>
        <template  slot-scope="scope">
          <el-button
            v-permission="'0020204'"
            size="mini"
            @click="addMaintain(scope.row.id)">差异流水</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="listState.pageNo"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>
  <add-modal :show.sync="addModalVisible" @onform="forms" :formData="addData"/>
  <automatic :show.sync="automaticVisible" @onform="forme"  :formData="addData"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import addModal from './addModal'
import automatic from './automatic'
import AjaxSelect from '../../../components/ajaxSelect/index'
import SearchSelect from '../../../components/searchSelect/index'
import MultiCascader from '../../../components/multiCascader/multi-cascader-base-element/multiCascader'

export default {
  name: 'saleQuery',
  components: { AjaxSelect, MultiCascader, SearchSelect, addModal, automatic },
  data () {
    return {
      ids: null,
      form: {
        tareWeightTime: []
      },
      tableData: [],
      addData: {},
      // 订单类型
      typeArr: [
        { value: 1, label: '是' },
        { value: 0, label: '否' }
      ],
      moneyType: [
        { value: '', label: '全部' },
        { value: 1, label: 'CNY' },
        { value: 2, label: 'USD' },
        { value: 3, label: 'EUR' }
      ],
      list: [{}],
      citisOptions: [],
      total: 0,
      listState: {
        pageSize: 10,
        pageNo: 1
      },
      addModalVisible: false,
      automaticVisible: false
    }
  },
  methods: {
    ...mapActions([
      'getFsapListe',
      'getFsapjob',
      'getFsapaddconfig',
      'getFsapListeup'
    ]),
    // 搜索
    handleSearch () {
      console.log('jashjdhashdk')
      const params = {
        verifyNo: this.form.verifyNo,
        isDifferent: this.form.isDifferent,
        // adjustType: this.form.ces2[0],
        // receiptNo: this.form.ces5,
        // takeOrderNo: this.form.ces6,
        // // currencyTypeList: this.form.ces3,
        // currencyType: this.form.ces3,
        // orgId: this.form.organization,
        // customerId: this.form.custom,
        // createTimeStart: this.form.tareWeightTime[0].substring(0, 10),
        // createTimeEnd: this.form.tareWeightTime[1].substring(0, 10),
        ...this.listState
      }
      if (this.form.tareWeightTime === null) {
        console.log(this.form.tareWeightTime)
        this.form.tareWeightTime = []
      }
      if (this.form.tareWeightTime.length === 2) {
        params.verifyDateStart = this.form.tareWeightTime[0].substring(0, 10)
        params.verifyDateEnd = this.form.tareWeightTime[1].substring(0, 10)
        console.log(params)
      }
      this.getFsapListe(params).then(res => {
        console.log(res, '8888')
        const { list, total, pageNum, pageSize } = res
        this.tableData = list
        this.total = total
        this.listState.pageNo = pageNum
        this.listState.pageSize = pageSize
      })
    },
    // 分页条数变更
    handleSizeChange (val) {
    },
    // 分页跳转
    handleCurrentChange (val) {
    },
    add () {
      this.addData = {}
      this.addModalVisible = true
    },
    automatic () {
      this.addData = {}
      // this.automaticVisible = true
      this.getFsapjob().then(res => {
        this.automaticVisible = true
        console.log(res, '999')
        this.ids = res.id
      })
    },
    addMaintain (e) {
      this.$router.push({ name: 'varianceJournal', query: { id: e } })
    },
    forms (e) {
      console.log(e.lockStartTime[0].substring(0, 4))
      if (e.lockStartTime[0].substring(0, 4) !== e.lockStartTime[1].substring(0, 4)) {
        this.$message.error('设置同步日期不得跨年')
        return
      }
      const params = {
        startDate: e.lockStartTime[0].substring(0, 10),
        endDate: e.lockStartTime[1].substring(0, 10)
      }
      console.log(params)
      this.getFsapListeup(params).then(res => {
        console.log(res, '8888')
        this.$message.success('新增资金同步对账成功')
        this.handleSearch()
        // const { list, total, pageNo, pageSize } = res.data
        // this.tableData = list
        // this.listState.total = total
        // this.listState.pageNo = pageNo
        // this.listState.pageSize = pageSize
      })
    },
    forme (e) {
      const params = {
        verifyType: e.offersFlag
      }
      if (this.ids) {
        params.id = this.ids
      }
      console.log(params)
      this.getFsapaddconfig(params).then(res => {
        console.log(res, '8888')
      })
    },
    // 查询表单，表格重置
    handleReset () {
      this.form.pageNo = 1
      this.form.pageSize = 20000
      this.form.organization = ''
      this.form.custom = ''
      this.$refs['form'].resetFields()
      // this.$refs['citisSelector'].reset()
      this.handleSearch()
    }
  },
  mounted () {
    this.isCheckRecord = ''
    this.form.orderTime = ''
    this.handleSearch()
  }
}
</script>

<style scoped>
.output-box{
margin-top: 20px;
text-align: right;
}
.input-page, .select-page{
  width: 98px;
  margin: 0 15px;
}
.input-page, .select-page-btn{
  width: 120px;
  margin: 0 15px;
}
</style>
